<div #strategyView class="popup-callout order-entry__panel-strategy__container bfx-test-strategy">
  <perfect-scrollbar
    #strategyLayoutPS
    class="strategy__viewer__diagram"
    [config]="control.scrollbarConfig"
    [usePSClass]
    [style.height.px]="style.scroll.height"
    [style.max-height.px]="style.scroll.maxHeight"
    [style.min-height.px]="style.scroll.minHeight"
    [style.width.px]="style.scroll.width"
    [style.max-width.px]="style.scroll.maxWidth"
    [style.min-width.px]="style.scroll.minWidth"
  >
    <div
      class="strategy__viewer__diagram__target"
      #strategyLayoutTarget
      (selection)="selectStrategy($event)"
      (remove)="removeStrategy($event)"
      [style.height.px]="style.layoutTarget.height"
      [style.max-height.px]="style.layoutTarget.maxHeight"
      [style.min-height.px]="style.layoutTarget.minHeight"
      [style.width.px]="style.layoutTarget.width"
      [style.max-width.px]="style.layoutTarget.maxWidth"
      [style.min-width.px]="style.layoutTarget.minWidth"
    ></div>
    <!-- (resize)="resizeStrategy($event)" -->
  </perfect-scrollbar>
</div>
